import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

interface Props {
  viewed: boolean;
}

const ViewedFlag = ({ viewed }: Props) => {
  const classes = useStyles();

  return (
    <Box className={viewed ? [classes.baseView, classes.viewed].join(' ') : [classes.baseView, classes.notViewed].join(' ')}>
      <Typography >{viewed ? 'Visualizado' : 'Não visualizado'}</Typography>
    </Box>

  );
}

export default ViewedFlag;

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    baseView: {
      maxHeight: 20,
      padding: theme.spacing(0, 2),
      backgroundColor: theme.palette.primary.contrastText,
      borderRadius: 50,
      display: "flex",
      alignItems: "center",

      "& p": {
        fontSize: theme.typography.pxToRem(11),
        fontWeight: theme.typography.fontWeightBold,
      },
    },
    viewed: {
      color: theme.palette.primary.main,
    },
    notViewed: {
      color: "#DC143C",
    },
  })
);

